import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { DocumentviewerComponent } from '../documentviewer/documentviewer.component';
import { PropertyOwnerModel } from '../models/propertyOwnerModel';
import { DocumentViewRequest } from '../models/documentViewRequest';
import { SecureDocument } from '../models/secureDocument';
import { DocumentType } from '../models/whatsappRequest';


@Component({
  selector: 'app-ownersdocuments',
  templateUrl: './ownersdocuments.component.html',
  styleUrls: ['./ownersdocuments.component.scss'],
  encapsulation:  ViewEncapsulation.None
})



export class OwnersdocumentsComponent implements OnInit {

  public owner : PropertyOwnerModel;
  constructor(private router: Router, private data: DataService) {
   
  }

  ngOnInit(): void {
    this.owner = this.data.SelectedOwner;
  }

  onViewDocument(documentid : SecureDocument, title: string){
    documentid.title = title;
    var req : DocumentViewRequest = new DocumentViewRequest();
    req.Document = documentid;
    req.DocType = DocumentType.msgtype_ownerdocument;
    this.data.ActiveDocumentViewRequest = req;
    this.router.navigate(['documentviewer'],{skipLocationChange: false});
  }
}
